export class ProductCode {
  public static ExcludedPartners = ['Rookie', 'Pro', 'Veteran'];
  public static NoPartners = ['Orange', 'Black', 'Diamond', 'Rookie', 'Pro', 'Veteran', 'Gold Glove'];
  public static Partners = ['Full Season Partner', 'Half Season Partner', 'Partial Season Partner', '6000Flex Partner'];
  public static Members = ['Full Season', 'Half Season', 'Partial Season', '6000Flex', '3000Flex', '1500Flex', '750Flex'];
  public static ShouldSeePartners = ['Full Season', 'Half Season', 'Partial Season', '6000Flex'];
}

export const ShouldSeePartners = ['Full Season', 'Half Season', 'Partial Season', '6000Flex'];
